// extracted by mini-css-extract-plugin
export default {"Board":"Board_Board__I9BJj","Row":"Board_Row__zrJL9"};